import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useLogSession } from "../../contexts/LogSessionContext";
import { useLang } from "../../contexts/LangContext";

export default function WhenLastTime() {
  const { person, setcurrentDayRecord, setcurrentMealRecord, setNewFishItem } =
    useLogSession();
  const navigate = useNavigate();
  const { t, lang } = useLang();

  function getLocalDateString(date: Date): string {
    const year = date.getFullYear();
    const month = `${date.getMonth() + 1}`.padStart(2, "0");
    const day = `${date.getDate()}`.padStart(2, "0");
    return `${year}-${month}-${day}`;
  }

  const days: string[] = [];
  const now = new Date();

  // Determine whether to include today
  const includeToday = now.getHours() >= 8; // Include today if it's 8 AM or later
  const startOffset = includeToday ? 0 : 1;

  for (let i = startOffset; i < startOffset + 7; i++) {
    const date = new Date(now);
    date.setDate(now.getDate() - i);
    days.push(getLocalDateString(date));
  }

  const consumedAny = days.some((date) => {
    return person.records.some((record) => {
      return (
        record.date === date &&
        record.meals &&
        record.meals.length > 0 &&
        record.meals.some(
          (meal) => meal.fish_items && meal.fish_items.length > 0
        )
      );
    });
  });

  const formatDate = (dateStr: string) => {
    const date = new Date(dateStr);
    // Show today as "Today (30 July)", yesterday as "Yesterday (29 July)", and format others
    if (date.toDateString() === now.toDateString()) {
      return `${t("today") || "Today"} (${date.toLocaleDateString(
        lang === "bn" ? "bn-BD" : "en-US",
        {
          day: "numeric",
          month: "long",
        }
      )})`;
    }
    const yesterday = new Date(now);
    yesterday.setDate(now.getDate() - 1);
    if (date.toDateString() === yesterday.toDateString()) {
      return `${t("yesterday") || "Yesterday"} (${date.toLocaleDateString(
        lang === "bn" ? "bn-BD" : "en-US",
        {
          day: "numeric",
          month: "long",
        }
      )})`;
    }
    return date.toLocaleDateString(lang === "bn" ? "bn-BD" : "en-US", {
      weekday: lang === "en" ? "short" : "long",
      month: lang === "en" ? "short" : "long",
      day: "numeric",
    });
  };

  useEffect(() => {
    setcurrentDayRecord(null); // Reset any previous day record
    setcurrentMealRecord(null);
    setNewFishItem(null);
  }, []);

  const handleSelect = (date: string) => {
    const existingRecord = person.records.find(
      (record) => record.date === date
    );

    setcurrentDayRecord(existingRecord || {
      date,
      meals: [],
      surveyed_on: getLocalDateString(new Date()),
    });

    navigate("../which-meal");
  };

  const handleAbort = () => {
    navigate("../abort");
  };

  return (
    <div className="flex flex-col items-center justify-center gap-8 mt-8 text-center px-scr pb-12">
      <h1 className="text-2xl font-bold text-rose-700">
        {t("whenLastTime_Heading")}
      </h1>

      <div className="flex flex-col gap-3 w-full max-w-xs">
        {days.map((d) => (
          <button
            key={d}
            onClick={() => handleSelect(d)}
            className="w-full button-base button-bg-grad-light-blue"
          >
            {formatDate(d)}
          </button>
        ))}

        <button
          onClick={handleAbort}
          className="w-full button-base button-bg-grad-2"
        >
          {t("whenLastTime_NoRecentFish")}
        </button>
      </div>
    </div>
  );
}
